import { _ as _slicedToArray, a as _toConsumableArray } from './_rollupPluginBabelHelpers-76ab84fa.js';
import React, { useState, useEffect } from 'react';

require("es6-promise").polyfill();

var WeducDairyDates = function WeducDairyDates(props) {
  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      newsFeedData = _useState4[0],
      setNewsFeedData = _useState4[1];

  useEffect(function () {
    var getApiData = function getApiData() {
      var dateToday = new Date(),
          y = dateToday.getFullYear(),
          m = dateToday.getMonth(),
          d = dateToday.getDate();
      var start = new Date(y, m, d);
      var end = new Date(y + 1, m, d);
      var weducAPIURL = props.weducAPIURL ? props.weducAPIURL : "https://weduc.accropress.com/smartfeed/";
      fetch(weducAPIURL + "getcalendareventsfordate/" + props.name + "/" + props.container + "?start_date=" + start.toISOString() + "&end_date=" + end.toISOString()).then(function (response) {
        return response.json();
      }).then(function (jsonList) {
        if (jsonList && jsonList.data && jsonList.data.events && jsonList.data.events.length > 0) {
          var startDate = new Date(start.toISOString());
          var endDate = new Date(end.toISOString());
          jsonList.data.events = jsonList.data.events.filter(function (a) {
            var date = new Date(new Date(a.start_date));
            return date >= startDate && date <= endDate;
          });
          jsonList.data.events = jsonList.data.events.reverse();

          if (props.limit && jsonList.data && jsonList.data.events) {
            jsonList.data.events = jsonList.data.events.splice(0, props.limit);
            setNewsFeedData(jsonList);
            setLoading(false);
          } else {
            setNewsFeedData(jsonList);
            setLoading(false);
          }

          props.loadedEvent(true);

          if (props.state && props.setState) {
            var temp = _toConsumableArray(props.state);

            jsonList.data && jsonList.data.events && jsonList.data.events.map(function (news, i) {
              temp.push({
                title: news.title,
                date: news.start_date,
                description: news.description
              });
            });
            props.setState(temp);
          }
        }

        setLoading(false);
      });
    };

    getApiData();
  }, []);
  var Html = props.html;

  if (!props.state && !props.setState && props.html) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, newsFeedData.data && newsFeedData.data.events ? newsFeedData.data.events.map(function (news, i) {
      return /*#__PURE__*/React.createElement(Html, {
        key: i,
        data: news,
        route: props.route,
        state: props.state,
        setState: props.setState
      });
    }) : loading ? /*#__PURE__*/React.createElement("div", {
      className: "components-loading-wrap"
    }, /*#__PURE__*/React.createElement("div", {
      className: "components-loading-spinner"
    }, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null)), /*#__PURE__*/React.createElement("span", null, "Loading diary dates")) : /*#__PURE__*/React.createElement("div", {
      className: "no-results"
    }, "There are no upcoming dates to display."));
  } else {
    return null;
  }
};

export default WeducDairyDates;